__turbopack_context__.v({
  "Dropdown": "LanguageToggle-module-scss-module__L2oRjW__Dropdown",
  "DropdownItem": "LanguageToggle-module-scss-module__L2oRjW__DropdownItem",
  "Link": "LanguageToggle-module-scss-module__L2oRjW__Link",
  "LinkActive": "LanguageToggle-module-scss-module__L2oRjW__LinkActive",
  "Toggle": "LanguageToggle-module-scss-module__L2oRjW__Toggle",
  "ToggleButton": "LanguageToggle-module-scss-module__L2oRjW__ToggleButton",
});
